import { Form, InputNumber, Typography } from "antd";

export default function ResidentialInfluentPercentage({ initialValue }) {
  return (
    <>
      <Form.Item
        label="Percent influent from residential (%)"
        name="influent_residential_perc"
        initialValue={initialValue}
        className="mb-0"
      >
        <InputNumber
          min={0}
          max={100}
          className="full-width"
          placeholder="Enter as percent value"
        />
      </Form.Item>
      <Typography.Text type="secondary">
        What percent of your influent comes from residential wastewater (vs. industrial or other non-residential sources). e.g. 80%, 100%?
      </Typography.Text>
    </>
  );
}
